module.exports = __webpack_public_path__ + "img/happiness.2f9596b5.svg";